import { Dropdown, Icon } from '@brighterion/br-ui';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import React, { CSSProperties, useRef, useState } from 'react';
import styles from './style.css';

interface RowAction {
    testId: string;
    label: string;
    handleAction: () => void;
    style?: CSSProperties;
}

interface RowActionDropdownProps {
    menuId: string;
    menuActions: RowAction[];
}

const RowActionDropdown = ({ menuId, menuActions }: RowActionDropdownProps) => {
    const [showClose, setShowClose] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const actions: JSX.Element[] = menuActions.map((ma) => (
        <div
            key={ma.testId}
            data-test-id={ma.testId}
            role='button'
            tabIndex={0}
            style={ma.style}
            onClick={handleOnClickEvent(ma.handleAction)}
            onKeyDown={handleKeyEvent(ma.handleAction)}
        >
            {ma.label}
        </div>
    ));

    const setParentZIndex = (setToZero?: boolean) => {
        if (dropdownRef.current && dropdownRef.current.parentElement) {
            dropdownRef.current.parentElement.style.zIndex = showClose || setToZero ? '0' : '9';
        }
    };
    const handleDropdown = () => {
        setShowClose(!showClose);
        setParentZIndex();
    };
    const children: JSX.Element[] = [
        <div
            key='row-action-menu-icon'
            onClick={handleOnClickEvent(handleDropdown)}
            onKeyDown={handleKeyEvent(handleDropdown)}
            onBlur={() => {
                setShowClose(false);
                setParentZIndex(true);
            }}
            role='button'
            tabIndex={0}
        >
            {showClose ? (
                <Icon data-testid='action-menu-close' name='close-x' size='md' />
            ) : (
                <Icon data-testid='action-menu-open' name='menu-vertical' size='md' />
            )}
        </div>,
        ...actions
    ];
    return (
        <div ref={dropdownRef}>
            <Dropdown
                id={menuId}
                containerClassName={styles.rowActionDropdown}
                showArrows={false}
                menuAlignment='right'
                closeOnClick
            >
                {children}
            </Dropdown>
        </div>
    );
};

export default RowActionDropdown;
